import * as React from 'react';

// mui
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

// icons
import InfoIcon from '@mui/icons-material/Info';

export default function MediaList() {

    return (
        <Tooltip
            title={
                <List
                    component="ol"
                    dense={true}
                    aria-label="Ordered list"
                    sx={{
                        listStyleType: "decimal",
                        pl: "1.5em",
                        ml: 1,
                        '& .MuiListItem-root': {
                            display: 'list-item',
                            textAlign: 'left',
                            pl: 1,
                        },
                    }}
                >
                    <ListItem>
                        <ListItemText
                            primary="メディア追加ボタンをクリックしてメディアアップロードページを開きます。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            primary={<>メディアアップロードページにて、画像もしくは、動画をアップロードします。<br />
                                アップロードされたメディアは、メディアカードとして表示されます。</>}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            primary="表示されたメディアカードの「画像コピー」または「動画コピー」ボタンをクリックして、画像または動画をコピーします。"
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            primary="コピーした画像または動画を編集中のエディターにペーストし、画像、動画を追加します。"
                        />
                    </ListItem>
                </List>
            }
        >
            <Typography
                component="h3"
                sx={{ display: "inline-block", mb: 1 }}
            >
                <InfoIcon sx={{
                    fontSize: 14,
                    verticalAlign: "middle",
                    mr: 1,
                }} />
                <Typography
                    component="span"
                    variant="caption"
                    sx={{
                        fontWeight: "bold",
                    }}
                >
                    メディアの挿入方法について
                </Typography>
            </Typography>
        </Tooltip>
    )
}